import HttpClient from 'httpClient/index';
import type { DataCountry } from 'common/dataService/types/countriesTypes';

const BASE_URL = `${process.env.REACT_APP_DATA_API || ''}/api/datacountries`;

class DataServiceDataCountries extends HttpClient {
  public constructor() {
    super(BASE_URL);
  }

  public getDataCountries = (): Promise<DataCountry[]> => this.instance.get('');
}

export default new DataServiceDataCountries();
